var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesLiked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.666992C30.6775 0.666992 39.333 9.3225 39.333 20C39.333 30.6775 30.6775 39.333 20 39.333C9.3225 39.333 0.666992 30.6775 0.666992 20C0.666992 9.3225 9.3225 0.666992 20 0.666992Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.666992C30.6775 0.666992 39.333 9.3225 39.333 20C39.333 30.6775 30.6775 39.333 20 39.333C9.3225 39.333 0.666992 30.6775 0.666992 20C0.666992 9.3225 9.3225 0.666992 20 0.666992Z",
    stroke: "#383838",
    strokeWidth: 1.33333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5342_225081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7646 12.5365C27.6862 11.3669 26.2064 10.7227 24.5975 10.7227C23.3949 10.7227 22.2936 11.1029 21.324 11.8526C20.8348 12.2311 20.3915 12.6941 20.0007 13.2345C19.61 12.6942 19.1665 12.2311 18.6771 11.8526C17.7077 11.1029 16.6064 10.7227 15.4038 10.7227C13.7949 10.7227 12.315 11.3669 11.2365 12.5365C10.171 13.6926 9.58398 15.2718 9.58398 16.9837C9.58398 18.7456 10.2406 20.3584 11.6503 22.0595C12.9114 23.581 14.7238 25.1257 16.8227 26.9143C17.5394 27.5251 18.3517 28.2175 19.1953 28.955C19.4181 29.1502 19.7041 29.2576 20.0007 29.2576C20.2971 29.2576 20.5832 29.1502 20.8057 28.9553C21.6492 28.2177 22.4621 27.525 23.1791 26.9138C25.2777 25.1255 27.0901 23.581 28.3512 22.0593C29.7609 20.3584 30.4173 18.7456 30.4173 16.9835C30.4173 15.2718 29.8303 13.6926 28.7646 12.5365Z",
    fill: "#FF2D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5342_225081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8333,
    height: 20.8333,
    fill: "white",
    transform: "translate(9.58398 9.58301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesLiked);
export default __webpack_public_path__ + "static/media/stories-liked.441f85670d7313cd4751b770a2603fda.svg";
export { ForwardRef as ReactComponent };